import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { ChartDateIntervalSelectorComponent } from './chart-date-interval-selector.component';

@NgModule({
  declarations: [
    ChartDateIntervalSelectorComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatTooltipModule
  ],
  exports: [
    ChartDateIntervalSelectorComponent
  ]
})
export class ChartDateIntervalSelectorModule { }
